var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExportData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 11.05L15.3667 11.9333L17.6083 14.175H10V15.425H17.6083L15.3667 17.6583L16.25 18.5417L20 14.8L16.25 11.05Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6917 5.80833L12.3167 1.43333C12.1917 1.30833 12.0667 1.25 11.875 1.25H4.375C3.68333 1.25 3.125 1.80833 3.125 2.5V17.5C3.125 18.1833 3.68333 18.75 4.375 18.75H10V17.5H4.375V2.5H10.625V6.25C10.625 6.93333 11.1917 7.5 11.875 7.5H15.625V10H16.875V6.25C16.875 6.05833 16.8167 5.93333 16.6917 5.80833ZM11.875 6.25V2.75L15.375 6.25H11.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExportData);
export default __webpack_public_path__ + "static/media/ic-export-data.774045f007f0839316d37527d40d955f.svg";
export { ForwardRef as ReactComponent };